<template>
    <b-card>
        <b-card-header>
            <b-button @click="savePackers()">Spara</b-button>
            <b-button @click="loadPackers()">Avbryt</b-button>
        </b-card-header>
        <b-card-body v-if="userslist" style="width:400px">
            <b-row v-for="(u, i) in userslist" :key="i">
                <b-col>
                    <b-input v-model="u.name"></b-input>
                </b-col>
                <b-col>
                    <b-icon-x-circle-fill v-on:click="remove(u)"></b-icon-x-circle-fill>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button @click="add()">Lägg till +</b-button>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import { Api } from '@/lib/api'
const api = new Api();

export default {
    name: 'packerslist',
    data() {
        return {
            userslist: null,
        }
    },
    mounted() {
        this.loadPackers();
    },
    methods: {
        loadPackers() {
            api.get('/api/sodexo/GetPackers').then(res => {
                this.userslist = res.data.map(x => { return { name: x } });
            })
        },
        savePackers() {
            if(this.userslist) {
                var p = this.userslist.map(x => x.name);
                api.post('/api/sodexo/SetPackers',p).then(res => {
                    alert(res.data);
                    this.loadPackers();
                });
            }
        },
        add() {
            if (this.userslist)
                this.userslist.push({name:''});
        },
        remove(u) {
            if (this.userslist && u)
                this.userslist = this.userslist.filter(x => x.name != u.name);
        }
    }
}

</script>
